module.exports = __webpack_public_path__ + "static/google-play-badge-0d9d47b1c19113b5ccd5b0a07e875872.png";